// extracted by mini-css-extract-plugin
module.exports = {"base":"_2KeX_n","floatingCloseBtn":"_1KJEfp","tabs":"_1i8LEK","slides":"kKNA2X"};